import { ImportWizardSynmedGcnComponent } from './../import-wizard-synmed-gcn/import-wizard-synmed-gcn.component';
import { SaveSynmedDrug } from './../../models/synmed-drug';
import { PassAnalyze, SynmedAnalyze } from './../../models/drug-qualifer';
import { ImportWizardDrugQualifierComponent } from '../import-wizard-drug-qualifier/import-wizard-drug-qualifier.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { LaunchDarklyService } from 'src/app/shared/services/launch-darkly.service';
import { ColumnName, Dropdwon, DrugType } from '../../models/column-name';
import { CommonEntity, CustomerAndFileInfo } from '../../models/customer-drug-info';
import { DrugInfoNew } from "../../models/DrugInfoNew";
import { LegacyConnectDrugInfo } from "../../models/legacy-connect-drug-info";
import { CustomerInfo, DeviceType } from '../../models/customer-info';
import { MainDeviceType, Country } from '../../models/device-type';
import { IMToolService } from '../../services/im-tool.service';
import * as constants from 'src/app/config/app-constants';
import { AlertWizardComponent } from '../alert-wizard/alert-wizard.component';
import { ImToolAtpService } from '../../services/im-tool-atp.service';
import { MatTableDataSource } from '@angular/material/table';
import { GroupCanister, AddGcnDrugs, AdjustGcnDrug, GcnDrugs, GroupBy, UpdateGroupCanister } from '../../models/gcn-drugs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AssignDrawerLocation, AtpDeiceDrawerCell, AtpDeviceSelectedDrawer } from '../../models/device-cell';
import { ImportWizardGcnMaxComponent } from '../import-wizard-gcn-max/import-wizard-gcn-max.component';
import { ImToolData } from '../../services/im-tool-data.service';
import { autoCanisterValidator } from '../../models/validator';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { config } from 'process';

@Component({
  selector: 'app-import-wizard',
  templateUrl: './import-wizard.component.html',
  styleUrls: ['./import-wizard.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: false
})
export class ImportWizardComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  subdeviceTypes: DeviceType[] = [];
  deviceTypes: MainDeviceType[] = ImToolData.devices;
  countries: Country[] = ImToolData.countries;

  deviceName: string = ''
  countryName: string = '';
  fielName: string = ''
  drugType: DrugType[] = [];
  noishDrugType: DrugType[] = [];
  selectedDeviceTypeId: number;
  countAnalysisDrugInfo: CommonEntity[] = [];
  countryCodeList: CommonEntity[] = [];
  ndcVariantList: Dropdwon[] = [];
  dayOfUsageList: CommonEntity[] = ImToolData.dayOfUsage;
  daysPerWeekList: CommonEntity[] = ImToolData.daysPerWeek;
  get datasourceList(): CommonEntity[] {
    return ImToolData.getDatasourceList(this.deviceId);
  }
  validationErrorMessage: string;
  drugNameSource: CommonEntity[] = [];
  errorMessages: string[] = [];

  isparentnotassociated: number = 1;
  showbackbutton: boolean = false;
  checkedDrug: string;
  isHighCapDrawerDisable: boolean = false;
  analyzeOpened: boolean = false;
  isDrugValidationEnabled: boolean = false;


  columnNameList: ColumnName[] = [];
  customerData: CustomerInfo[] = [];

  drugwithCanisterInfoModel: DrugInfoNew;
  legacyConnectDrugInfoModel: LegacyConnectDrugInfo;
  synmedDrugModel: SaveSynmedDrug;


  customerAndFileInfoModel: CustomerAndFileInfo;

  // File Upload Information form
  isButtonSelectLargeBottle: boolean = false;
  isLowestUsageDrugSelect: boolean = false;
  isHighestUsageDrugSelect = false;
  isUnselectAll = false;


  primaryDrugName: FormControl;
  secondaryDrugName: FormControl;
  isCustomerMnemonic: FormControl;



  // Drug and Canister Information Save form
  isCellSecure: FormControl;
  configuration: FormControl;
  drugWithCanisterForm: FormGroup;
  cellAssignment: FormControl;
  deviceId: number;
  deviceTypeId: FormControl;
  isOtcExcluded: FormControl;
  isScheduleExcluded: FormControl;
  isUnitOfUsageExcluded: FormControl;
  isNioshExcluded: FormControl;
  unitOfUsageQty30: FormControl;
  unitOfUsageQty60: FormControl;
  unitOfUsageQty90: FormControl;
  unitOfUsageValue: string[] = [];
  orderOrUsage: FormControl;
  usageValue: FormControl;
  canisterQuantity: FormControl;
  canisterSize: FormControl;
  searchText: FormControl;
  dataSourceId: FormControl;
  //Start: Drug Type check box model value take
  drugTypeOne: FormControl;
  drugTypeTwo: FormControl;
  drugTypeThree: FormControl;
  drugTypeFour: FormControl;
  drugTypeFive: FormControl;
  parataConnectFlowDrugForm: FormGroup;
  //End: Drug Type check box model value take

  //START: Niosh Drug checkbox model value
  drugAntineoplastic: FormControl;
  drugNonAntineoplastic: FormControl;
  drugReproductive: FormControl;

  superCellNo: FormControl;
  lockingCellNo: FormControl;
  regularCellNo: FormControl;
  superLockingCellNo: FormControl;

  emptySuperCellNo: FormControl;
  emptyLockingCellNo: FormControl;
  emptyRegularCellNo: FormControl;
  emptySuperLockingCellNo: FormControl;

  scheduleExcludedValue: string[] = ["C-I"];
  noUsage: FormControl;


  minimumDaysSupply: FormControl;
  minimumDaysSupplyMax: FormControl;

  highCapDrawerNo: FormControl;
  smartDrawerNo: FormControl;
  highCapSmartDrawerNo: FormControl;
  dayOfUse: FormControl;
  initalCanister: FormControl;
  smartCanister: FormControl;
  highCapCanister: FormControl;
  smartHighCapCanister: FormControl;
  excludeAntibiotics: FormControl;
  ndcVariant: FormControl;


  ///PASS
  passInitialSmallCanister: FormControl;
  passInitialLargeCanister: FormControl;
  autoCanister: FormControl;
  daysOfWeek: FormControl;
  // Synmed Device

  machineNumber: FormControl;
  capsAssetNumber: FormControl;
  customerNumber: FormControl;
  countryCode: FormControl;
  synmedAnalyzeData: SynmedAnalyze = {};
  synMedLanguage: FormControl;


  /// pass Device

  passanalyzeData: PassAnalyze = {} as PassAnalyze;


  nioshValue: number[] = [1];

  //#region GCN Import Wizard
  @ViewChild("TABLE") table: ElementRef;
  @ViewChild('dialogContent') dialogContent: ElementRef;
  @ViewChild('analyzeDiv', { read: ElementRef }) analyzeDiv: ElementRef;

  dataSource = new MatTableDataSource<GcnDrugs>([]);
  gcnNumberList: GroupBy[] = [];
  isColorChange: boolean = false;
  gcnDrugList: GcnDrugs[] = [];
  gcnDrugdModel: AdjustGcnDrug;
  customerId: string;
  customerName: string;
  saveGcnDrugListModel: AddGcnDrugs[] = [];
  selectedGcnDrugList: GcnDrugs[] = [];


  displayedColumns: string[] = [
    "checkbox",
    "sl",
    "drugName",
    "gcnNumber",
    "ndc",
    "packageSize",
    "manufacturer",
    "strength",
    "unitOfUsage",
    "rxQty",
  ];
  selectedRow: any;
  //#endregion

  //#region Group Canister
  @ViewChild("TABLE1") table1: ElementRef;
  dataSourceGroupCanister = new MatTableDataSource<GroupCanister>([]);


  displayedColumnsGroupCanister: string[] = [
    'checkbox',
    'topOrder',
    'name',
    'ndc',
    'strength',
    'usage',
    'daysOfPillQtyReq',
    'bottleQty',
    'maxCap',
    'hccMaxCap',
    'recCanister',
    'groupCanister',
    'recHcCanister',
    'highCapGroupCanister',
  ];

  selectGroupCanistherList: GroupCanister[] = [];
  groupCanisterModel: UpdateGroupCanister;
  saveGroupDrugListModel: GroupCanister[] = [];
  //#endregion
  handleDeviceIdChange(deviceId: number) {
    this.deviceId = deviceId;
    this.deviceTypes.forEach(x => {
      if (x.id == deviceId) {
        this.deviceName = x.deviceName
      }
    })
    if (this.deviceId !== 6) {
      this.capsAssetNumber.clearValidators();
      this.capsAssetNumber.updateValueAndValidity();
    }
    this.getSystemDevieType(deviceId);
    this.updateSubDevice();

    // Ensure drug name dropdowns are populated after device change
    this.setDrugNameSource(this.dataSourceId.value);

  }

  handleCountryIdChange(countryId: number) {
    this.countryName = countryId == 1 ? "USA" : countryId == 2 ? "CANADA" : "";
    this.countryCode.setValue(this.countryName);
    this.updateDataSourceDisabledState();
  }
  private updateDataSourceDisabledState(): void {
    const shouldDisable = this.isDrugValidationEnabled && this.countryName === 'USA';
    if (shouldDisable && this.dataSourceId.enabled) {
      this.dataSourceId.disable({ emitEvent: false });
    } else if (!shouldDisable && this.dataSourceId.disabled) {
      this.dataSourceId.enable({ emitEvent: false });
    }
  }
  handleNoUsage(noUsage: boolean) {
    this.noUsage.setValue(noUsage);
    console.log(this.noUsage.value)
  }

  handleDataSourceIdChange(sourceId: number) {
    this.dataSourceId.setValue(sourceId);
    this.setDrugNameSource(sourceId);
  }

  constructor(
    private imtoolService: IMToolService,
    private imToolAtpService: ImToolAtpService,
    public dialogRefImportWizardComponent: MatDialogRef<ImportWizardComponent>,
    public dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private toastService: ToastService,
    private fb: FormBuilder,
    private launchDarklyService: LaunchDarklyService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.customerData.push(data.customer);
    this.hidesite(data.isparentnotassociated === undefined ? 1 : data.isparentnotassociated);
    this.noUsage = new FormControl(false);


    this.dataSourceId = new FormControl(5, Validators.required)
    this.configuration = new FormControl(1, Validators.required);
    this.cellAssignment = new FormControl(1, Validators.required);
    this.deviceTypeId = new FormControl("", Validators.required);
    this.isCellSecure = new FormControl(false);
    this.isOtcExcluded = new FormControl(false);
    this.isScheduleExcluded = new FormControl(true);
    this.isUnitOfUsageExcluded = new FormControl(false);
    this.isNioshExcluded = new FormControl(true);
    this.unitOfUsageQty30 = new FormControl(0);
    this.unitOfUsageQty60 = new FormControl(0);
    this.unitOfUsageQty90 = new FormControl(0);
    this.orderOrUsage = new FormControl(1);
    this.usageValue = new FormControl(2);
    this.canisterQuantity = new FormControl("");
    this.canisterSize = new FormControl();
    this.searchText = new FormControl(null);

    this.superCellNo = new FormControl(0);
    this.lockingCellNo = new FormControl(0);
    this.emptySuperCellNo = new FormControl(0);
    this.emptySuperLockingCellNo = new FormControl(0);
    this.emptyRegularCellNo = new FormControl(0);
    this.emptyLockingCellNo = new FormControl(0);

    this.drugTypeOne = new FormControl(1);
    this.drugTypeTwo = new FormControl(0);
    this.drugTypeThree = new FormControl(0);
    this.drugTypeFour = new FormControl(0);
    this.drugTypeFive = new FormControl(0);


    this.drugAntineoplastic = new FormControl(1);
    this.drugNonAntineoplastic = new FormControl(0);
    this.drugReproductive = new FormControl(0);

    this.minimumDaysSupply = new FormControl(0);
    this.autoCanister = new FormControl(0, [Validators.required, autoCanisterValidator(this.deviceTypeId.value)]);
    this.passInitialLargeCanister = new FormControl(0);
    this.passInitialSmallCanister = new FormControl(0);
    this.highCapDrawerNo = new FormControl(0);
    this.highCapSmartDrawerNo = new FormControl(0);

    this.smartDrawerNo = new FormControl(0);
    this.dayOfUse = new FormControl(0);
    this.initalCanister = new FormControl(0);
    this.smartCanister = new FormControl(0);
    this.highCapCanister = new FormControl(0);
    this.smartHighCapCanister = new FormControl(0);

    this.regularCellNo = new FormControl(0);
    this.excludeAntibiotics = new FormControl(false);
    this.superLockingCellNo = new FormControl(0);
    this.primaryDrugName = new FormControl('2');
    this.secondaryDrugName = new FormControl('1');

    this.machineNumber = new FormControl('');
    this.capsAssetNumber = new FormControl(this.customerData[0].assetNumber, [
      Validators.required,
      ImportWizardComponent.assetNumberValidator
    ]);

    this.customerNumber = new FormControl({ value: this.customerData[0].customerNumber, disabled: true });
    this.synMedLanguage = new FormControl('');
    this.countryCode = new FormControl('');
    this.ndcVariant = new FormControl(1);
    this.isCustomerMnemonic = new FormControl(false);
    this.daysOfWeek = new FormControl(1);
    this.drugWithCanisterForm = this.fb.group({
      dataSourceId: this.dataSourceId,
      minimumDaysSupply: this.minimumDaysSupply,
      autoCanister: this.autoCanister,
      passInitialLargeCanister: this.passInitialLargeCanister,
      passInitialSmallCanister: this.passInitialSmallCanister,
      highCapDrawerNo: this.highCapDrawerNo,
      smartDrawerNo: this.smartDrawerNo,
      highCapSmartDrawerNo: this.highCapSmartDrawerNo,
      dayOfUse: this.dayOfUse,
      initalCanister: this.initalCanister,
      smartCanister: this.smartCanister,
      drugAntineoplastic: this.drugAntineoplastic,
      drugNonAntineoplastic: this.drugNonAntineoplastic,
      drugReproductive: this.drugReproductive,
      drugTypeOne: this.drugTypeOne,
      drugTypeTwo: this.drugTypeTwo,
      drugTypeThree: this.drugTypeThree,
      drugTypeFour: this.drugTypeFour,
      drugTypeFive: this.drugTypeFive,
      configuration: this.configuration,
      isCellSecure: this.isCellSecure,
      deviceTypeId: this.deviceTypeId,
      isOtcExcluded: this.isOtcExcluded,
      isScheduleExcluded: this.isScheduleExcluded,
      isUnitOfUsageExcluded: this.isUnitOfUsageExcluded,
      canisterQuantity: this.canisterQuantity,
      canisterSize: this.canisterSize,
      searchText: this.searchText,
      scheduleExcludedValue: this.scheduleExcludedValue,
      nioshValue: this.nioshValue,
      superCellNo: this.superCellNo,
      lockingCellNo: this.lockingCellNo,
      superLockingCellNo: this.superLockingCellNo,
      cellAssignment: this.cellAssignment,
      emptySuperCellNo: this.emptySuperCellNo,
      emptySuperLockingCellNo: this.emptySuperLockingCellNo,
      emptyRegularCellNo: this.emptyRegularCellNo,
      emptyLockingCellNo: this.emptyLockingCellNo,
      isNioshExcluded: this.isNioshExcluded,
      unitOfUsageQty30: this.unitOfUsageQty30,
      unitOfUsageQty60: this.unitOfUsageQty60,
      unitOfUsageQty90: this.unitOfUsageQty90,
      excludeAntibiotics: this.excludeAntibiotics,
      highCapCanister: this.highCapCanister,
      smartHighCapCanister: this.smartHighCapCanister,
      isHighCapDrawerDisable: this.isHighCapDrawerDisable,
      primaryDrugName: this.primaryDrugName,
      secondaryDrugName: this.secondaryDrugName,
      machineNumber: this.machineNumber,
      capsAssetNumber: this.capsAssetNumber,
      customerNumber: this.customerNumber,
      synMedLanguage: this.synMedLanguage,
      countryCode: this.countryCode,
      ndcVariant: this.ndcVariant,
      daysOfWeek: this.daysOfWeek
    });

    this.parataConnectFlowDrugForm = this.fb.group({
      dataSourceId: this.dataSourceId,
      drugTypeOne: this.drugTypeOne,
      drugTypeTwo: this.drugTypeTwo,
      drugTypeThree: this.drugTypeThree,
      drugTypeFour: this.drugTypeFour,
      drugTypeFive: this.drugTypeFive,
      isOtcExcluded: this.isOtcExcluded,
      isScheduleExcluded: this.isScheduleExcluded,
      isUnitOfUsageExcluded: this.isUnitOfUsageExcluded,
      scheduleExcludedValue: this.scheduleExcludedValue,
      nioshValue: this.nioshValue,      
      isNioshExcluded: this.isNioshExcluded,
      unitOfUsageQty30: this.unitOfUsageQty30,
      unitOfUsageQty60: this.unitOfUsageQty60,
      unitOfUsageQty90: this.unitOfUsageQty90,
      excludeAntibiotics: this.excludeAntibiotics,
      countryCode: this.countryCode
    });
    this.customerId = this.customerData[0].customerId;


  }

  ngOnInit(): void {
    const flagKey = 'drug-validation-wizard-feature';
    this.isDrugValidationEnabled = this.launchDarklyService.getBooleanFlag(flagKey, false);
    console.log('[DrugValidationFlag]', this.isDrugValidationEnabled);

    // Lock Data Source when drug validation wizard is enabled AND country is USA.
    this.updateDataSourceDisabledState();

    this.launchDarklyService.flagChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((flags: Record<string, unknown>) => {
        if (Object.prototype.hasOwnProperty.call(flags, flagKey)) {
          this.isDrugValidationEnabled = Boolean(flags[flagKey]);
          this.updateDataSourceDisabledState();
        }
      });

    this.ndcVariantList.push({ key: 1, value: 'CDDB Drug Id' },
      { key: 2, value: 'Customer Drug Id' },
      { key: 3, value: 'Customer Mnemonic' })



    if (this.isparentnotassociated === 2) {
      this.getImportWizardData()
    }

    if (this.deviceId === 2) {
      this.formValidataionUpdate();
    }
    this.resetConfigValues();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onScroll() {
    const checkContent = () => {
      if (this.analyzeDiv && this.analyzeDiv.nativeElement) {
        this.dialogContent.nativeElement.scrollTop = this.dialogContent.nativeElement.scrollHeight;
      } else {
        setTimeout(checkContent, 100);
      }
    };
    setTimeout(checkContent, 0);
  }

  updateSubDevice() {
    if (this.deviceTypeId.value === 20 || this.deviceTypeId.value === 21) {
      this.autoCanister.setValue(1);
    }
    else {
      this.autoCanister.setValue(0);
    }

    this.drugWithCanisterForm.controls["autoCanister"].setValidators(autoCanisterValidator(this.deviceTypeId.value));
  }
  validationForPassDevice() {
    const deviceType = this.deviceTypeId.value;
    const limits = ImToolData.deviceTypeLimits[deviceType];

    if (!limits) {
      return null;
    }

    const value = this.autoCanister.value;
    const { min, max } = limits;

    if (value < min || value > max) {
      this.toastService.openToast(
        `The number of Auto Canisters must be between ${min} and ${max}.`,
        constants.ToastPanelType.warning,
        3
      );
      return true;
    }
    return false;
  }
  getAutoCanisterErrorMessage(): string {
    const control = this.drugWithCanisterForm.get('autoCanister');

    if (control?.hasError('autoCanisterInvalid')) {
      const deviceTypeId = this.deviceTypeId.value;

      switch (deviceTypeId) {
        case 18:
        case 19:
          return 'The number of Auto Canisters must be between 0 to 4.';
        case 20:
          return 'The number of Auto Canisters must be between 0 to 6.';
        case 21:
          return 'The number of Auto Canisters must be between 0 to 8.';
        default:
          return '';
      }
    }

    if (control?.hasError('autoCanisterExceeded')) {
      return 'The number of Auto Canisters exceeds the available large canisters.';
    }

    return '';
  }

  isEmpty(obj: Record<string, any>): boolean {
    return Object.keys(obj).length === 0;
  }




  onChange(schedule: string, isChecked: boolean) {
    if (isChecked) {
      this.scheduleExcludedValue.push(schedule)
    } else {
      let index = this.scheduleExcludedValue.findIndex(
        (x) => x == schedule
      );
      this.scheduleExcludedValue.splice(index, 1);
      if (schedule == "C-I")
        this.drugTypeOne.setValue(0)
      else if (schedule == "C-II")
        this.drugTypeTwo.setValue(0)
      else if (schedule == "C-III")
        this.drugTypeThree.setValue(0)
      else if (schedule == "C-IV")
        this.drugTypeFour.setValue(0)
      else if (schedule == "C-V")
        this.drugTypeFive.setValue(0)
    }
  }


  resetDrugsCheckbox() {
    if (this.isScheduleExcluded.value == false) {
      this.scheduleExcludedValue = [];
      this.drugTypeOne.setValue(0)
      this.drugTypeTwo.setValue(0)
      this.drugTypeThree.setValue(0)
      this.drugTypeFour.setValue(0)
      this.drugTypeFive.setValue(0)
    }
    if (this.isNioshExcluded.value == false) {
      this.nioshValue = [];
      this.drugAntineoplastic.setValue(0)
      this.drugNonAntineoplastic.setValue(0)
      this.drugReproductive.setValue(0)
    }
    if (this.isUnitOfUsageExcluded.value == false) {
      this.unitOfUsageValue = [];
      this.unitOfUsageQty30.setValue(0);
      this.unitOfUsageQty60.setValue(0);
      this.unitOfUsageQty90.setValue(0);
    }
  }

  onChangeUnitOfUsage(qty: string, isChecked: boolean) {
    if (isChecked) {
      this.unitOfUsageValue.push(qty);
    } else {
      const index = this.unitOfUsageValue.findIndex((x) => x == qty);
      if (index > -1) {
        this.unitOfUsageValue.splice(index, 1);
      }
      if (qty == "30")
        this.unitOfUsageQty30.setValue(0);
      else if (qty == "60")
        this.unitOfUsageQty60.setValue(0);
      else if (qty == "90")
        this.unitOfUsageQty90.setValue(0);
    }
  }

  onChangeNioshDrug(schedule: number, isChecked: boolean) {

    if (isChecked) {
      this.nioshValue.push(schedule);
    } else {
      let index = this.nioshValue.findIndex((x) => x == schedule);
      this.nioshValue.splice(index, 1);
      if (schedule == 1)
        this.drugAntineoplastic.setValue(0)
      else if (schedule == 2)
        this.drugNonAntineoplastic.setValue(0)
      else if (schedule == 3)
        this.drugReproductive.setValue(0)
    }
  }

  isUndefined(variable): boolean {
    return typeof variable === 'undefined' || variable === null

  }
  synmedValidation(): boolean {
    if (this.isUndefined(this.machineNumber.value) || this.machineNumber.value.length === 0) {
      return false
    }
    if (this.isUndefined(this.synMedLanguage.value) || this.synMedLanguage.value.length === 0) {
      return false
    }

    return true;
  }

  getSystemDevieType(id: any) {


    if (id == 4) {
      this.getCountries();
    }
    this.analyzeOpened = false;
    const SYSTEMKEY = 'Systemkey'
    this.ngxLoader.start(SYSTEMKEY)
    this.imtoolService.getSystemDeviceType(id).subscribe(
      (response) => {
        let result = response.data;
        this.subdeviceTypes = [];
        result?.forEach(element => {
          this.subdeviceTypes.push({
            subDeviceTypeId: element.id,
            deviceTypeId: element.deviceTypeId,
            subDeviceTypeName: element.deviceTypeName,
            isActive: element.isActive
          })
        });
        this.resetValueUnderAnalyze();
        this.ngxLoader.stop(SYSTEMKEY);
        this.deviceTypeId.setValue(this.deviceId === 5 ? 6 : this.deviceTypeId.value);
      },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop(SYSTEMKEY);
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );
  }

  getCountries() {
    const COUNTRY_KEY = 'countrykey'
    this.ngxLoader.start(COUNTRY_KEY)
    this.imtoolService.getCountries().subscribe(
      (response: any) => {
        let result = response.data;
        this.countryCodeList = [];
        result?.forEach(element => {
          this.countryCodeList.push({
            key: element.key,
            value: element.value
          })
        });
        this.ngxLoader.stop(COUNTRY_KEY);
      },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop(COUNTRY_KEY);
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );
  }

  getDeviceType() {
    const DEVICETYPE_KEY = 'Devicetype'
    this.ngxLoader.start(DEVICETYPE_KEY)
    this.imtoolService.getDeviceType().subscribe(
      (result) => {
        this.deviceTypes = result.data;
        this.ngxLoader.stop(DEVICETYPE_KEY);
      },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop(DEVICETYPE_KEY);
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );
  }

  resetValueUnderAnalyze() {
    this.countAnalysisDrugInfo = [];
    this.deviceTypeId.setValue(null);
  }

  getInvalidSuperCellMessage() {
    if (this.hasInvalidSuperCell()) {
      if (this.deviceId === 5) {
        return "Minimum Super cells value is 0";
      }
      return "Minimum Super cells value is 22";
    }
    return null;  // No error message if validation passes
  }

  getInvalidPassInitialCanistersMessage() {

    if (this.deviceId === 2 && (this.passInitialSmallCanister.value === null || this.passInitialSmallCanister.value === '')) {
      return "Minimum Pass Initial Canister value is 0";
    }
    return null;
  }

  prepareLegacyConnectCustomerDrugModel() {
    const formValue = this.parataConnectFlowDrugForm.getRawValue();
    // Prepare the model for legacy connect customer drug

    const isScheduleExcluded = formValue.isScheduleExcluded;
    const isNioshExcluded = formValue.isNioshExcluded;
    const isUnitOfUsageExcluded = formValue.isUnitOfUsageExcluded;
    const deviceTypeIdVal = this.subdeviceTypes.length > 0 ? this.subdeviceTypes[0].subDeviceTypeId : 0;

    this.legacyConnectDrugInfoModel = {
      customerId: this.customerData[0].customerId,
      deviceId: this.deviceId,
      unitOfUsageValue: isUnitOfUsageExcluded ? this.unitOfUsageValue.toString() : '',
      isOtcExcluded: formValue.isOtcExcluded,
      isScheduleExcluded: isScheduleExcluded,
      isUnitOfUsageExcluded: isUnitOfUsageExcluded,
      isNioshExcluded: isNioshExcluded,
      nioshValue: isNioshExcluded ? this.nioshValue.toString() : '',
      scheduleExcludedValue: isScheduleExcluded ? this.scheduleExcludedValue.toString() : '',
      excludeAntibiotics: formValue.excludeAntibiotics == null || this.dataSourceId.value == 1 ? false : formValue.excludeAntibiotics, 
      countryCode: this.countryName,     
      dataSource: formValue.dataSourceId,
      deviceTypeId: deviceTypeIdVal
    };
  }


  loadCustomerDrugListForLegacyConnect(){
    this.prepareLegacyConnectCustomerDrugModel();

     const LEGACYINFOSAVE_KEY = 'Legacyconnectinfosavekey';
    this.ngxLoader.start(LEGACYINFOSAVE_KEY);
    this.imtoolService
      .drugInfoForLegacyConnectSaveNew(this.legacyConnectDrugInfoModel)
      .subscribe(
        (result) => {
          this.ngxLoader.stop(LEGACYINFOSAVE_KEY);
          this.handleSaveResultLegacyConnect(result);
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop(LEGACYINFOSAVE_KEY);
          this.handleError(error);
        }
      );
  }

  drugWithCanisterInfoSave() {
    if (!this.isFormValid()) return;


    const invalidSuperCellMessage = this.getInvalidSuperCellMessage();

    if (invalidSuperCellMessage) {
      this.toastService.openToast(
        invalidSuperCellMessage,
        constants.ToastPanelType.error,
        2
      );
      return;
    }

    const invalidPassInitialCanistersMessage = this.getInvalidPassInitialCanistersMessage();

    if (invalidPassInitialCanistersMessage) {
      this.toastService.openToast(
        invalidPassInitialCanistersMessage,
        constants.ToastPanelType.error,
        2
      );
      return;
    }


    this.prepareDrugWithCanisterModel();

    const DEVICEINFOSAVE_KEY = 'Deviceinfosavekey';
    this.ngxLoader.start(DEVICEINFOSAVE_KEY);
    this.imtoolService
      .drugInfoWithCanisterSaveNew(this.drugwithCanisterInfoModel)
      .subscribe(
        (result) => {
          this.ngxLoader.stop(DEVICEINFOSAVE_KEY);
          this.handleSaveResult(result);
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop(DEVICEINFOSAVE_KEY);
          this.handleError(error);
        }
      );
  }

  isFormValid() {
    return this.drugWithCanisterForm.valid &&
      !this.validataionMessage() &&
      !this.atpValidationForAnalyze() &&
      !this.atpCapsValidationForAnalyze() &&
      this.analyzeOpened !== false;
  }

  isLegacyConnectFormValid() {
    return this.parataConnectFlowDrugForm.valid &&
      this.analyzeOpened !== false;
  }

  hasInvalidSuperCell() {
    return (this.deviceId === 1 && this.deviceTypeId.value === 1 && this.analyzeOpened && this.superCellNo.value < 22) ||
      (this.deviceId === 5 && this.analyzeOpened && this.superCellNo.value < 0);
  }

  prepareDrugWithCanisterModel() {
    const formValue = this.drugWithCanisterForm.getRawValue();
    // Only include exclusion values if the parent exclude is checked
    const isScheduleExcluded = formValue.isScheduleExcluded;
    const isNioshExcluded = formValue.isNioshExcluded;
    const isUnitOfUsageExcluded = formValue.isUnitOfUsageExcluded;

    this.drugwithCanisterInfoModel = {
      customerId: this.customerData[0].customerId,
      deviceTypeId: formValue.deviceTypeId == null ? 0 : formValue.deviceTypeId,
      deviceId: this.deviceId,
      unitOfUsageValue: isUnitOfUsageExcluded ? this.unitOfUsageValue.toString() : '',
      isOtcExcluded: formValue.isOtcExcluded,
      isScheduleExcluded: isScheduleExcluded,
      isUnitOfUsageExcluded: isUnitOfUsageExcluded,
      atpExcludedValue: "",
      isAtpExcluded: false,
      regularCellNo: 0,
      availableCellLoc: "",
      superCellNo: formValue.superCellNo,
      lockingCellNo: formValue.lockingCellNo,
      superLockingCellNo: formValue.superLockingCellNo,
      configuration: formValue.configuration,
      emptySuperCellNo: formValue.emptySuperCellNo,
      emptySuperLockingCellNo: formValue.emptySuperLockingCellNo,
      emptyLockingCellNo: formValue.emptyLockingCellNo,
      emptyRegularCellNo: formValue.emptyRegularCellNo,
      cellAssignment: formValue.cellAssignment,
      isCellSecure: formValue.isCellSecure,
      isNioshExcluded: isNioshExcluded,
      nioshValue: isNioshExcluded ? this.nioshValue.toString() : '',
      scheduleExcludedValue: isScheduleExcluded ? this.scheduleExcludedValue.toString() : '',
      isActive: true,
      excludeAntibiotics: formValue.excludeAntibiotics == null || this.dataSourceId.value == 1 ? false : formValue.excludeAntibiotics,
      minimumDaysSupply: formValue.minimumDaysSupply,
      daysOfUse: formValue.dayOfUse ?? 0,
      smartDrawer: formValue.smartDrawerNo,
      highCapDrawer: formValue.highCapDrawerNo,
      highCapSmartDrawer: formValue.highCapSmartDrawerNo,
      initialCanister: formValue.initalCanister,
      initialSmartCanister: formValue.smartCanister,
      initialHighCapCanister: formValue.highCapCanister,
      InitialHighCapSmartCanister: formValue.smartHighCapCanister,
      primaryDrugKey: formValue.primaryDrugName,
      secondaryDrugKey: formValue.secondaryDrugName,
      ndcVariant: formValue.ndcVariant,
      daysOfWeek: formValue.daysOfWeek,
      passAutoCanister: formValue.autoCanister,
      passLargeCanister: formValue.passInitialSmallCanister,
      passSmallCanister: formValue.passInitialLargeCanister,
      dataSource: formValue.dataSourceId,
      countryCode: this.countryName,
      assetNumber: this.capsAssetNumber.value
    };
  }

  handleSaveResultLegacyConnect(result) {
    if (result.statusCode === 200) {
      this.route.navigate(["/im-tool/legacy-connect", this.customerId], {
        queryParams: { sourceId: this.legacyConnectDrugInfoModel.dataSource }
      });
      this.closeDialog(true);
    } else {
      this.toastService.openToast(
        result.message,
        constants.ToastPanelType.error,
        2
      );
    }
  }

  handleSaveResult(result) {
    if (result.statusCode === 200) {
      this.toastService.openToast(
        result.message,
        constants.ToastPanelType.done,
        2
      );
      this.hidesite(3);
    } else {
      this.toastService.openToast(
        result.message,
        constants.ToastPanelType.error,
        2
      );
    }
  }

  handleError(error: HttpErrorResponse) {
    this.toastService.openToast(
      error.error.message ?? error.message,
      constants.ToastPanelType.error,
      2
    );
  }

  synmedDrugSave() {
    if (!this.drugWithCanisterForm.valid || this.analyzeOpened === false || !this.synmedValidation()) {
      return;
    }

    // Use getRawValue to always include disabled controls
    let formValue = this.drugWithCanisterForm.getRawValue();
    this.synmedDrugModel = {
      customerId: this.customerData[0].customerId,
      deviceTypeId: formValue.deviceTypeId == null ? 0 : formValue.deviceTypeId,
      deviceId: this.deviceId,
      dataSource: formValue.dataSourceId,
      unitOfUsageValue: this.unitOfUsageValue.toString(),
      isOtcExcluded: formValue.isOtcExcluded,
      isScheduleExcluded: formValue.isScheduleExcluded,
      isUnitOfUsageExcluded: formValue.isUnitOfUsageExcluded,
      isNioshExcluded: formValue.isNioshExcluded,
      nioshValue: this.nioshValue.toString(),
      scheduleExcludedValue: this.scheduleExcludedValue.toString(),
      machineNumber: formValue.machineNumber,
      synMedLanguage: this.synMedLanguage.value,
      countryCode: formValue.countryCode,
      ndcVariant: formValue.ndcVariant,
      excludeAntibiotics: formValue.excludeAntibiotics == null || this.dataSourceId.value == 1 ? false : formValue.excludeAntibiotics

    };
    const SYNMEDDEVICEINFO_KEY = 'Synmeddeviceinfokey'
    this.ngxLoader.start(SYNMEDDEVICEINFO_KEY);
    this.imtoolService
      .synmedDrugInfoWithCanisterSave(this.synmedDrugModel)
      .subscribe(
        (result) => {
          this.ngxLoader.stop(SYNMEDDEVICEINFO_KEY);
          if (result.statusCode == 200) {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.done,
              2
            );

            this.hidesite(3)
          } else {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.error,
              2
            );
          }
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop(SYNMEDDEVICEINFO_KEY);
          console.log(error);
          this.toastService.openToast(
            error.error.message ?? error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  onAnalyze() {
    this.endPointRequestSentBasedOnDevice(true);
  }

  onDataSourceSelected(sourceId: number): void {
    if (Number(sourceId) !== 5 || Number(this.deviceId) !== 3) {
      return;
    }
    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: ImToolData.legacyAtpWkWarningDialog,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.data !== true) {
        this.dataSourceId.setValue(1);
      }
    });
  }

  endPointRequestSentBasedOnDevice(isWizardLoad: boolean = true) {
    switch (this.deviceId) {
      case 1:
      case 5:
        this.getDrugMaxAnalysisData();
        break;
      case 2:
        this.getPassAnalysisData();
        break;
      case 3:
        this.getDrugAtpAnalysisData();
        break;
      case 4:
        if (isWizardLoad === true) {
          this.openImportWizardDrugQualifier();
        }
        break;
      case 6:
        this.getDrugAtpCapsAnalysisData();
        break;
      case 7:
        this.analyzeOpened = true;
        break;
    }

    setTimeout(() => {
      this.onScroll();
    }, 3000);
  }

  openImportWizardDrugQualifier() {
    if (this.deviceTypeId.value > 0) {
      const dialogRef = this.dialog.open(ImportWizardDrugQualifierComponent, {
        backdropClass: ['lgDialog'],
        disableClose: true,
        data: {
          customerId: this.customerId,
          deviceId: this.deviceId,
          subDeviceId: this.deviceTypeId.value,
          dataSourceId: this.dataSourceId.value
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result != null) {
          this.synmedAnalyzeData.bothSmallCount = result.data.bothSmallCount;
          this.synmedAnalyzeData.bothLargeCount = result.data.bothLargeCount;
          this.synmedAnalyzeData.bothEitherCount = result.data.bothEitherCount;
          this.synmedAnalyzeData.fragileCount = result.data.fragileCount;
          this.synmedAnalyzeData.largeEitherCount = result.data.largeEitherCount;
          this.synmedAnalyzeData.largeLargeCount = result.data.largeLargeCount;
          this.synmedAnalyzeData.largeSmallCount = result.data.largeSmallCount;
          this.synmedAnalyzeData.schedule2DrugCount = result.data.schedule2DrugCount;
          this.synmedAnalyzeData.smallEitherCount = result.data.smallEitherCount;
          this.synmedAnalyzeData.smallLargeCount = result.data.smallLargeCount;
          this.synmedAnalyzeData.smallSmallCount = result.data.smallSmallCount;
          this.synmedAnalyzeData.toggleCount = result.data.toggleCount;
          this.synmedAnalyzeData.nonCetritifedDrugs = result.data.nonCetritifedDrugs;
          this.analyzeOpened = true;
        } else {
          console.log("No change implement", result);
        }
        this.synmedDrugSave();
      });
    }
    else {
      this.toastService.openToast(
        'please select the sub-device',
        constants.ToastPanelType.warning,
        2
      );
    }
  }

  openImportWizardSynmedGcn() {
    const dialogRef = this.dialog.open(ImportWizardSynmedGcnComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
      data: {
        customerId: this.customerId
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data.status) {
        this.hidesite(result.data.wizardNumber);
      } else {
        this.dialogRefImportWizardComponent.close()
        console.log("Cancel=", result);
      }
    });
  }

  openImportWizardMaxGcnComponent() {
    const dialogRef = this.dialog.open(ImportWizardGcnMaxComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
      data: {
        customerId: this.customerId,
        deviceId: this.deviceId
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data.status) {
        this.hidesite(result.data.wizardNumber);
      } else {
        this.dialogRefImportWizardComponent.close()
        console.log("Cancel=", result);
      }
    });
  }
  getDrugAtpAnalysisData() {
    if (this.dayOfUse.value === null || this.dayOfUse.value === 0) {
      return;
    }
    const ATPANALYSISDATA_KEY = 'Atpanalysisdatakey'
    this.ngxLoader.start(ATPANALYSISDATA_KEY);
    this.imToolAtpService.getAtpAnalizeData(this.deviceTypeId.value, this.customerData[0].customerId,
      this.dayOfUse.value, this.highCapDrawerNo.value ?? 0, this.smartDrawerNo.value ?? 0, this.highCapSmartDrawerNo.value ?? 0).subscribe((result) => {
        this.ngxLoader.stop(ATPANALYSISDATA_KEY);
        this.countAnalysisDrugInfo = result.data;
        this.initalCanister.setValue(parseInt(this.countAnalysisDrugInfo[0]?.value == '' ? '0' : this.countAnalysisDrugInfo[0]?.value));
        this.highCapCanister.setValue(parseInt(this.countAnalysisDrugInfo[2]?.value == '' ? '0' : this.countAnalysisDrugInfo[2]?.value));
        this.smartCanister.setValue(parseInt(this.countAnalysisDrugInfo[1]?.value == '' ? '0' : this.countAnalysisDrugInfo[1]?.value))
        this.smartHighCapCanister.setValue(parseInt(this.countAnalysisDrugInfo[3]?.value == '' ? '0' : this.countAnalysisDrugInfo[3]?.value))

        this.analyzeOpened = true;
      },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop(ATPANALYSISDATA_KEY);
          console.log(error);
          this.toastService.openToast(
            error.error.message ?? error.message,
            constants.ToastPanelType.error,
            2
          );
        })
  }

  getDrugAtpCapsAnalysisData() {
    if (this.dayOfUse.value === null || this.dayOfUse.value === 0) {
      return;
    }
    const ATPANALYSISDATA_KEY = 'Atpanalysisdatakey'
    this.ngxLoader.start(ATPANALYSISDATA_KEY);
    this.imToolAtpService.getAtpCapsAnalyzeData(this.deviceTypeId.value, this.customerData[0].customerId,
      this.dayOfUse.value, this.highCapDrawerNo.value ?? 0, this.smartDrawerNo.value ?? 0, this.highCapSmartDrawerNo.value ?? 0).subscribe((result) => {
        this.ngxLoader.stop(ATPANALYSISDATA_KEY);
        this.countAnalysisDrugInfo = result.data;
        this.initalCanister.setValue(parseInt(this.countAnalysisDrugInfo[0]?.value == '' ? '0' : this.countAnalysisDrugInfo[0]?.value));
        this.highCapCanister.setValue(parseInt(this.countAnalysisDrugInfo[2]?.value == '' ? '0' : this.countAnalysisDrugInfo[2]?.value));
        this.smartCanister.setValue(parseInt(this.countAnalysisDrugInfo[1]?.value == '' ? '0' : this.countAnalysisDrugInfo[1]?.value))
        this.smartHighCapCanister.setValue(parseInt(this.countAnalysisDrugInfo[3]?.value == '' ? '0' : this.countAnalysisDrugInfo[3]?.value))

        this.analyzeOpened = true;
      },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop(ATPANALYSISDATA_KEY);
          console.log(error);
          this.toastService.openToast(
            error.error.message ?? error.message,
            constants.ToastPanelType.error,
            2
          );
        })
  }
  getPassAnalysisData() {
    if (!this.validateDeviceTypeSelection()) {
      return; // Exit if validation fails
    }
    if (this.validationForPassDevice()) {
      return;
    }
    const Passkey = 'Passanalysisdatakey';
    this.ngxLoader.start(Passkey);
    this.imtoolService.getPassAnalysisData(
      this.deviceTypeId.value,
      this.customerData[0].customerId,
      this.minimumDaysSupply.value,
      this.autoCanister.value,
      1,
      // this.dayOfUse.value,
      1//  this.daysOfWeek.value,
    ).subscribe((response) => {
      this.ngxLoader.stop(Passkey);
      response.data.forEach(item => {
        switch (item.key) {
          case 'Small Location':
            this.passanalyzeData.availableSmallLocation = item.value;
            break;
          case 'Large Location':
            this.passanalyzeData.availableLargeLocation = item.value;
            break;
          case 'Small Canister':
            this.passanalyzeData.smallCanisterDrugs = item.value;
            break;
          case 'Large Canister':
            this.passanalyzeData.largeCanisterDrugs = item.value;
            break;
        }
      });
      this.analyzeOpened = true;
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop(Passkey);
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }
  validateDeviceTypeSelection(): boolean {
    // Check if device type is selected
    if (this.deviceTypeId.value === 0 || this.deviceTypeId.value === null || this.deviceTypeId.value === '') {
      this.toastService.openToast(
        'You must select a sub-device type to proceed. Please choose a valid option from the list.',
        constants.ToastPanelType.error,
        2
      );
      return false;
    }

    // Check if auto canister is valid
    if (this.autoCanister == null || this.autoCanister.value === '') {
      this.toastService.openToast(
        'Auto Canister cannot be null or empty. Please provide a valid value.',
        constants.ToastPanelType.error,
        2
      );
      return false;
    }

    // If both validations pass
    return true;
  }

  getDrugMaxAnalysisData() {
    const MAXANALYSISDATA_KEY = 'Maxanalysisdatakey';
    this.ngxLoader.start(MAXANALYSISDATA_KEY);
    this.imtoolService.getAnalysisDataById(this.customerData[0].customerId, this.dataSourceId.value).subscribe((result) => {
      this.ngxLoader.stop(MAXANALYSISDATA_KEY);
      this.countAnalysisDrugInfo = result.data;
      this.analyzeOpened = true;
    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop(MAXANALYSISDATA_KEY);
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }


  hidesite(wizardNumber: number) {
    this.isparentnotassociated = wizardNumber;
    this.showbackbutton = this.isparentnotassociated === 2;

    if (this.isparentnotassociated === 4 && (this.deviceId === 1 || this.deviceId == 5)) {
      this.openImportWizardMaxGcnComponent();
    }
    if (this.isparentnotassociated === 4 && this.deviceId === 4) {
      this.openImportWizardSynmedGcn();
    }

  }

  isEmptySuperCellExceeded(): boolean {
    const configValue = this.drugWithCanisterForm.value.configuration;
    if (configValue === 3) {
      return false;
    }
    if (this.deviceId === 1 && this.emptySuperCellNo.value > this.superCellNo.value - this.superLockingCellNo.value) {
      this.toastService.openToast("Empty Super Quantity exceeds the Super Quantity ", constants.ToastPanelType.error, 2);
      this.emptySuperCellNo.setValue(0);
      return true;
    }

    return false;
  }
  isEmptySuperLockingCellExceeded(): boolean {
    const configValue = this.drugWithCanisterForm.value.configuration;
    if (configValue === 1) {
      return false;
    }
    else if (configValue === 3 && this.deviceId === 1 && this.emptySuperLockingCellNo.value > this.superCellNo.value) {
      this.toastService.openToast("Empty Super Locking Quantity exceeds the Super Locking Quantity ", constants.ToastPanelType.error, 2);
      this.emptySuperLockingCellNo.setValue(0);
      return true;
    }
    else if (this.deviceId === 1 && this.emptySuperLockingCellNo.value > this.superLockingCellNo.value && configValue != 3) {
      this.toastService.openToast("Empty Super Locking Quantity exceeds the Super Locking Quantity ", constants.ToastPanelType.error, 2);
      this.emptySuperLockingCellNo.setValue(0);
      return true;
    }

    return false;
  }
  isEmptyRegularCellExceeded(): boolean {
    const configValue = this.drugWithCanisterForm.value.configuration;
    if (configValue === 3) {
      return false;
    }
    var availableCells = 198;
    if (this.deviceTypeId.value === 2) {
      availableCells = 200;
    }
    else if (this.deviceTypeId.value === 22) {
      availableCells = 49
    }

    var regularQty = availableCells - (this.superCellNo.value * 2 + this.lockingCellNo.value);
    console.log('Regular qty ' + regularQty);
    if (this.deviceId === 1 && this.emptyRegularCellNo.value > regularQty) {
      this.toastService.openToast("Empty Regular Quantity exceeds the Regular Quantity ", constants.ToastPanelType.error, 2);
      this.emptyRegularCellNo.setValue(0);
      return true;
    }

    return false;
  }

  isEmptyRegularLockingCellExceeded(): boolean {
    const configValue = this.drugWithCanisterForm.value.configuration;
    if (configValue === 1) {
      return false;
    }
    var availableCells = 198;
    if (this.deviceTypeId.value === 2) {
      availableCells = 200;
    }
    else if (this.deviceTypeId.value === 22) {
      availableCells = 49
    }
    var regularLockingCell = availableCells - (this.superCellNo.value * 2);
    if (configValue === 3 && this.deviceId === 1 && this.emptyLockingCellNo.value > regularLockingCell) {
      this.toastService.openToast("Empty Locking Quantity exceeds the Locking Quantity ", constants.ToastPanelType.error, 2);
      this.emptyLockingCellNo.setValue(0);
      return true;
    }
    if (this.deviceId === 1 && this.emptyLockingCellNo.value > this.lockingCellNo.value && configValue != 3) {
      this.toastService.openToast("Empty Locking Quantity exceeds the Locking Quantity ", constants.ToastPanelType.error, 2);
      this.emptyLockingCellNo.setValue(0);
      return true;
    }

    return false;
  }
  resetEmptyValues() {
    this.emptyRegularCellNo.setValue(0);
    this.emptyLockingCellNo.setValue(0);
    this.emptySuperCellNo.setValue(0);
    this.emptySuperLockingCellNo.setValue(0);
  }

  resetConfigValues() {
    this.regularCellNo.setValue(0);
    this.lockingCellNo.setValue(0);
    this.superLockingCellNo.setValue(0);

    const configValue = this.drugWithCanisterForm.value.configuration;
    const lockingCellControl = this.drugWithCanisterForm.get('emptyLockingCellNo');
    const superLockingCellControl = this.drugWithCanisterForm.get('emptySuperLockingCellNo');
    const regularCellControl = this.drugWithCanisterForm.get('emptyRegularCellNo');
    const superCellControl = this.drugWithCanisterForm.get('emptySuperCellNo');
    lockingCellControl?.setValue(0);
    superLockingCellControl?.setValue(0);
    regularCellControl?.setValue(0);
    superCellControl?.setValue(0);

    if (configValue == 1) {     
      lockingCellControl?.disable();
      superLockingCellControl?.disable();
    } else {
      lockingCellControl?.enable();
      superLockingCellControl?.enable();
    }

    if (configValue == 3) {      
      regularCellControl?.disable();
      superCellControl?.disable();
    } else {
      regularCellControl?.enable();
      superCellControl?.enable();
    }
  }

  isCellAssignInvalid(): boolean {
    if ((this.deviceId === 1 || this.deviceId === 5) && this.cellAssignment.value === 2 &&
      this.emptyLockingCellNo.value <= 0 && this.emptySuperLockingCellNo.value <= 0 &&
      this.emptyRegularCellNo.value <= 0 && this.emptySuperCellNo.value <= 0
    ) {
      return true;
    }
    return false;
  }

  emptyCellValidataionMessage(): boolean {
    if (this.isEmptySuperCellExceeded() || this.isEmptyRegularCellExceeded() ||
      this.isEmptySuperLockingCellExceeded() || this.isEmptyRegularLockingCellExceeded() ||
      this.isCellAssignInvalid()
    ) {
      return true;
    }

    return this.isAnalyzeButtonDisabled();
  }

  validataionMessage(): boolean {
    if (this.isSuperCellExceeded() || this.isSuperCellBelowMinimum() ||
      this.isSuperLockingCellExceeded() || this.isLockingCellExceeded() ||
      this.isConfigurationInvalid() || this.isDaysOfWeekUndefined() || this.isPassInitialCanisterExceeded() ||
      this.isDayOfUseInvalid()) {
      return true;
    }

    return this.isAnalyzeButtonDisabled();
  }

  isSuperCellExceeded(): boolean {
    var deviceTypeId = this.deviceTypeId.value;

    if (this.deviceId === 1 && deviceTypeId === 2 && this.superCellNo.value > 89) {
      this.toastService.openToast("Super Quantity exceeds the superMax limit", constants.ToastPanelType.error, 2);
      this.superCellNo.setValue(0);
      return true;
    }
    if (this.deviceId === 1 && (deviceTypeId === 5 || deviceTypeId === 23) && this.superCellNo.value > 88) {
      this.toastService.openToast("Super Quantity exceeds the superMax limit", constants.ToastPanelType.error, 2);
      this.superCellNo.setValue(0);
      return true;
    }
    if ((this.deviceId === 5 || (this.deviceId === 1 && deviceTypeId === 22)) && this.superCellNo.value > 23) {
      this.toastService.openToast("Super Quantity exceeds the superMax limit: 23", constants.ToastPanelType.error, 2);
      this.superCellNo.setValue(0);
      return true;
    }
    return false;
  }

  isSuperCellBelowMinimum(): boolean {
    if (this.superCellNo.value < 0) {
      this.toastService.openToast("Minimum SuperCell quantity: 0", constants.ToastPanelType.error, 2);
      this.superCellNo.setValue(0);
      return true;
    }
    return false;
  }

  isSuperLockingCellExceeded(): boolean {
    if ((this.deviceId === 1 || this.deviceId === 5) && this.superLockingCellNo.value > this.superCellNo.value) {
      this.toastService.openToast("Super Locking Cell cannot exceed Super Cell", constants.ToastPanelType.error, 2);
      this.superLockingCellNo.setValue(0);
      return true;
    }
    return false;
  }

  formValidataionUpdate() {
    if (this.deviceId === 2) {
      this.drugWithCanisterForm.controls["passInitialSmallCanister"].setValidators(Validators.required);
    }
  }

  isPassInitialCanisterExceeded(): boolean {

    if (this.deviceId === 2 && this.passInitialSmallCanister.value > this.passanalyzeData.availableSmallLocation + this.passanalyzeData.availableLargeLocation) {

      if (this.passInitialSmallCanister.value == null || this.passInitialSmallCanister.value === '') {
        this.toastService.openToast("Please enter Initial Canisters ", constants.ToastPanelType.error, 2);
        return true;
      }
      else {
        let sum = this.passanalyzeData.availableSmallLocation + this.passanalyzeData.availableLargeLocation;
        this.toastService.openToast("Initial Canisters should not be more than sum of Available Small and Large Locations : " + sum, constants.ToastPanelType.error, 2);
        this.passInitialSmallCanister.setValue('');
        return true;
      }

    }

    return false;
  }

  isLockingCellExceeded(): boolean {
    var maxLockingCellAvailable = 200;
    var deviceTypeId = this.deviceTypeId.value;

    if (deviceTypeId === 5 || deviceTypeId === 23) {
      maxLockingCellAvailable = 198;
    }
    if (deviceTypeId === 22) {
      maxLockingCellAvailable = 49;
    }

    const maxLockingCellForDevice1 = maxLockingCellAvailable - (this.superCellNo.value * 2);
    const maxLockingCellForDevice5 = 49 - (this.superCellNo.value * 2);

    if (this.deviceId === 1 && this.lockingCellNo.value > maxLockingCellForDevice1) {
      this.toastService.openToast("Locking cell cannot exceed regular Cell: " + maxLockingCellForDevice1, constants.ToastPanelType.error, 2);
      this.lockingCellNo.setValue(0);
      return true;
    }

    if (this.deviceId === 5 && this.lockingCellNo.value > maxLockingCellForDevice5) {
      this.toastService.openToast("Locking cell cannot exceed regular Cell: " + maxLockingCellForDevice5, constants.ToastPanelType.error, 2);
      this.lockingCellNo.setValue(0);
      return true;
    }

    return false;
  }

  isConfigurationInvalid(): boolean {
    if ((this.deviceId === 1 || this.deviceId === 5) && this.configuration.value === 2 &&
      this.lockingCellNo.value <= 0 && this.superLockingCellNo.value <= 0) {
      return true;
    }
    return false;
  }

  isDaysOfWeekUndefined(): boolean {
    const daysOfWeek = this.drugWithCanisterForm.get('daysOfWeek').value;
    if ((this.deviceId === 1 || this.deviceId === 5) && this.isUndefined(daysOfWeek)) {
      return false; // Depending on your logic, adjust this condition
    }
    return false;
  }

  isDayOfUseInvalid(): boolean {
    if ((this.deviceId === 1 || this.deviceId === 3 || this.deviceId === 5) &&
      (this.dayOfUse.value === null || this.dayOfUse.value === 0)) {
      if ((this.deviceId === 1 || this.deviceId === 5) && this.noUsage.value === true) {
        return false;
      }
      return true;
    }
    return false;
  }


  redirectDrugList(deviceId: number) {
    this.dialogRefImportWizardComponent.close();
    if (deviceId === 3) {
      this.route.navigate(["/im-tool/atp-export", this.customerData[0].customerId]);
    }
    else if (deviceId === 4) {
      this.route.navigate(["/im-tool/synmed-export", this.customerData[0].customerId]);
    }
    else if (deviceId === 5) {
      this.route.navigate(["/im-tool/mini-export", this.customerData[0].customerId]);
    }
    else if (deviceId === 6) {
      this.route.navigate(["/im-tool/atp-caps-export", this.customerData[0].customerId]);
    }
    else {
      this.route.navigate(["/im-tool/export", this.customerData[0].customerId]);
    }

  }


  getImportWizardData() {
    const IMPORTWIZARDDATA_KEY = 'Importwizardatakey'
    this.ngxLoader.start(IMPORTWIZARDDATA_KEY);

    this.imtoolService.getImportWizardData(this.customerData[0].customerId).subscribe((response) => {
      let result = response.data;
      let count = 0;
      let dataBindInterval = setInterval(() => {
        this.deviceId = result.deviceId;
        this.isNioshExcluded.setValue(result.isNioshExcluded);
        this.isOtcExcluded.setValue(result.isOtcExcluded);
        this.isScheduleExcluded.setValue(result.isScheduleExcluded);
        this.isUnitOfUsageExcluded.setValue(result.isUnitOfUsageExcluded);
        this.lockingCellNo.setValue(result.lockingCellNo);
        this.regularCellNo.setValue(result.regularCellNo);
        this.deviceTypeId.setValue(result.deviceTypeId);
        this.superCellNo.setValue(result.superCellNo);
        this.superLockingCellNo.setValue(result.superLockingCellNo);
        this.emptySuperCellNo.setValue(result.emptySuperCellNo);
        this.emptySuperLockingCellNo.setValue(result.emptySuperLockingCellNo);
        this.emptySuperCellNo.setValue(result.emptySuperCellNo);
        this.emptySuperCellNo.setValue(result.emptySuperCellNo);
        this.emptySuperCellNo.setValue(result.emptySuperCellNo);
        this.dataSourceId.setValue(result.dataSource);
        this.configuration.setValue(result.configurationType?.toString());
        this.isCellSecure.setValue(result.isCellSecure);
        this.highCapCanister.setValue(result.highCapCanister);
        this.dayOfUse.setValue(result.daysOfUse?.toString());
        this.initalCanister.setValue(result.initialCanister);
        this.highCapDrawerNo.setValue(result.highCapDrawer);
        this.highCapSmartDrawerNo.setValue(result.highCapSmartDrawer);
        this.excludeAntibiotics.setValue(result.excludeAntibiotics);
        this.highCapCanister.setValue(result.initialHighCapCanister);
        this.smartHighCapCanister.setValue(result.InitialHighCapSmartCanister);
        this.smartCanister.setValue(result.initialSmartCanister);
        this.minimumDaysSupply.setValue(result.minimumDaysSupply);
        this.smartDrawerNo.setValue(result.smartDrawer);
        this.countryCode.setValue(result.countryCode);
        this.machineNumber.setValue(result.machineNumber);
        this.customerNumber.setValue(this.customerData[0].customerNumber);
        // Keep the passed-in assetNumber if API doesn't return one
        this.capsAssetNumber.setValue(result.capsAssetNumber || this.customerData[0].assetNumber);
        this.synMedLanguage.setValue(result.synMedLanguage);
        this.noUsage.setValue(result.noUsage);
        this.ndcVariant.setValue(result.ndcVariant)
        this.isCustomerMnemonic.setValue(result.isCustomerMnemonic)
        this.autoCanister.setValue(result.passAutoCanister);
        this.passInitialLargeCanister.setValue(result.passLargeCanister);
        this.passInitialSmallCanister.setValue(result.passSmallCanister);
        if (result.scheduleExcludedValue) {
          this.scheduleExcludedValue = [];

          result.scheduleExcludedValue.split(',').forEach(x => {
            this.scheduleExcludedValue.push(x);
            if (x == 1) {
              this.drugTypeOne.setValue(x);
            }
            else if (x == 2) {
              this.drugTypeTwo.setValue(x);
            }
            else if (x == 3) {
              this.drugTypeThree.setValue(x);
            }
            else if (x == 4) {
              this.drugTypeFour.setValue(x);
            }
            else if (x == 5) {
              this.drugTypeFive.setValue(x);
            }
          })
        }
        if (result.nioshExcludedValue != null || result.nioshExcludedValue != undefined) {
          this.nioshValue = [];
          result.nioshExcludedValue.split(',').forEach(x => {
            this.nioshValue.push(x);
            if (x == 1) {
              this.drugAntineoplastic.setValue(x)
            }
            else if (x == 2) {
              this.drugNonAntineoplastic.setValue(x)
            }
            else if (x == 3) {
              this.drugReproductive.setValue(x)
            }
          })
        }
        if (
          result.unitOfUsageValue !== null &&
          result.unitOfUsageValue !== undefined &&
          result.unitOfUsageValue !== ''
        ) {
          this.unitOfUsageValue = [];
          const value = Number(result.unitOfUsageValue);
          if (value & 1) {
            this.unitOfUsageValue.push('30');
            this.unitOfUsageQty30.setValue('30');
          } else {
            this.unitOfUsageQty30.setValue('');
          }
          if (value & 2) {
            this.unitOfUsageValue.push('60');
            this.unitOfUsageQty60.setValue('60');
          } else {
            this.unitOfUsageQty60.setValue('');
          }
          if (value & 4) {
            this.unitOfUsageValue.push('90');
            this.unitOfUsageQty90.setValue('90');
          } else {
            this.unitOfUsageQty90.setValue('');
          }
        }

        this.ngxLoader.stop(IMPORTWIZARDDATA_KEY);
        count++;
        if (count === 2) {
          clearInterval(dataBindInterval)
          this.ngxLoader.stop(IMPORTWIZARDDATA_KEY);
          this.endPointRequestSentBasedOnDevice(false);
        }
      }, 500)
      this.handleDeviceIdChange(result.deviceId);
      this.countryName = result.countryCode;
      // Country is only known here when the wizard opens on page 2 (Change Device).
      this.updateDataSourceDisabledState();

    },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop(IMPORTWIZARDDATA_KEY);
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      })
  }

  onToggleSourceChange(event: any) {
    this.isCellSecure = event.checked;
  }
  /*Input box readonly set*/
  isReadOnly: boolean = false;
  isReadOnlyForLite: boolean = false;

  isDisabled() {
    if (this.deviceTypeId.value === 9) { this.highCapDrawerNo.setValue(0); }
    if (this.deviceId === 2) {
      this.updateSubDevice()
    }

    if (this.drugWithCanisterForm.get('deviceTypeId').value == 3) {
      this.superCellNo.setValue(36);
      this.isReadOnlyForLite = true;
      this.isReadOnly = true;
      this.lockingCellNo.setValue(0);
      this.superLockingCellNo.setValue(0);
      this.configuration.setValue(1);
    }
    else if (this.drugWithCanisterForm.get('deviceTypeId').value == 4) {
      this.superCellNo.setValue(45);
      this.isReadOnlyForLite = true;
      this.isReadOnly = true;
      this.lockingCellNo.setValue(0);
      this.superLockingCellNo.setValue(0);
      this.configuration.setValue(1);
    }
    else if (this.drugWithCanisterForm.get('deviceTypeId').value == 5) {
      this.isReadOnlyForLite = true;
      this.superCellNo.setValue(88);
      this.isReadOnly = false;
    }
    else if (this.drugWithCanisterForm.get('deviceTypeId').value == 23) {
      this.superCellNo.setValue(22);
      this.isReadOnlyForLite = false;
      this.isReadOnly = false;
    }
    else {
      this.isReadOnly = false;
      this.superCellNo.setValue(0);
      this.isReadOnlyForLite = false;
    }
  }

  isAnalyzeButtonDisabled() {
    if ((this.isScheduleExcluded.value == true && this.scheduleExcludedValue.length === 0) ||
      (this.isNioshExcluded.value == true && this.nioshValue.length === 0) || (this.isUnitOfUsageExcluded.value == true && this.unitOfUsageValue.length === 0)) {
      this.countAnalysisDrugInfo = [];
      this.isDisabled();

      this.superCellNo.setValue(0);

      this.isReadOnlyForLite = false;
      return true;
    }
    else if ((this.deviceId === 2 || this.deviceId === 3 || this.deviceId === 4) && (this.deviceTypeId.value == null || this.dayOfUse.value === null || this.dayOfUse.value === 0)) {
      return true;
    }
    else {
      return false;
    }

  }

  atpValidationForAnalyze(): boolean {

    let output = false;
    let sd128 = 8 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let sHcd192 = 4 - this.highCapDrawerNo.value;
    let sd192 = 12 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let sHcd256 = 8 - this.highCapDrawerNo.value;
    let sd256 = 16 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let sd320 = 20 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let sHcd400 = 10 - this.highCapDrawerNo.value;
    let sd400 = 25 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let sHcd480 = 12 - this.highCapDrawerNo.value;
    let sd480 = 30 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let initialCan: number = parseInt(this.countAnalysisDrugInfo[0]?.value == '' ? '0' : this.countAnalysisDrugInfo[0]?.value);
    let initialHighCan: number = parseInt(this.countAnalysisDrugInfo[2]?.value == '' ? '0' : this.countAnalysisDrugInfo[2]?.value);
    let initialSmartCan: number = parseInt(this.countAnalysisDrugInfo[1]?.value == '' ? '0' : this.countAnalysisDrugInfo[1]?.value);
    let initialSmartHighCan: number = parseInt(this.countAnalysisDrugInfo[3]?.value == '' ? '0' : this.countAnalysisDrugInfo[3]?.value);


    if (this.deviceId === 3 && this.initalCanister.value > initialCan) {
      output = true;
      this.initalCanister.setValue(initialCan);
      this.toastService.openToast(`Maximum Initial Canister value : ${initialCan}`,
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceId === 3 && this.highCapCanister.value > initialHighCan) {
      this.highCapCanister.setValue(initialHighCan);
      output = true;
      this.toastService.openToast(`Maximum Initial High Canister value : ${initialHighCan}`,
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceId === 3 && this.smartHighCapCanister.value > initialSmartHighCan) {
      this.smartHighCapCanister.setValue(initialSmartHighCan);
      output = true;
      this.toastService.openToast(`Maximum Initial High Canister value : ${initialSmartHighCan}`,
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceId === 3 && this.smartCanister.value > 999) {
      this.smartCanister.setValue(initialSmartCan);
      output = true;
      this.toastService.openToast("Maximum Initial Smart Canister value : 999",
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceTypeId.value === 9 && this.highCapDrawerNo.value > 0) {
      this.highCapDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("High Cap Drawer not possible for ATP2-64 device",
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceTypeId.value === 9 && this.highCapSmartDrawerNo.value > 0) {
      this.highCapSmartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Smart High Cap Drawer not possible for ATP2-64 device",
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceTypeId.value === 9 && this.smartDrawerNo.value > 4) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Maximum Smart Drawer value for ATP2-64 device : 4",
        constants.ToastPanelType.error,
        2
      );
    }
    else if ((this.deviceTypeId.value === 10 || this.deviceTypeId.value === 11) && this.highCapDrawerNo.value > 4) {
      this.highCapDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Maximum High Cap Drawer value : 4",
        constants.ToastPanelType.error,
        2
      );

    }
    else if ((this.deviceTypeId.value === 10 || this.deviceTypeId.value === 11) && this.highCapSmartDrawerNo.value > sHcd192) {
      this.highCapSmartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart High Cap Drawer value : ${sHcd192}`,
        constants.ToastPanelType.error,
        2
      );

    }

    else if (this.deviceTypeId.value === 10 && this.smartDrawerNo.value > sd128) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawer value : ${sd128}`,
        constants.ToastPanelType.error,
        2
      );

    }
    else if (this.deviceTypeId.value === 11 && this.smartDrawerNo.value > sd192) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawer value : ${sd192}`,
        constants.ToastPanelType.error,
        2
      );
    }

    else if ((this.deviceTypeId.value === 12 || this.deviceTypeId.value === 13) && this.highCapDrawerNo.value > 8) {
      this.highCapDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Maximum High Cap Drawer value : 8",
        constants.ToastPanelType.error,
        2
      );
    }
    else if ((this.deviceTypeId.value === 12 || this.deviceTypeId.value === 13) && this.highCapSmartDrawerNo.value > sHcd256) {
      this.highCapSmartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart High Cap Drawer value : ${sHcd256}`,
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceTypeId.value === 12 && this.smartDrawerNo.value > sd256) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawers value : ${sd256}`,
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceTypeId.value === 13 && this.smartDrawerNo.value > sd320) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawers value : ${sd320}`,
        constants.ToastPanelType.error,
        2
      );
    }

    else if ((this.deviceTypeId.value === 14) && this.highCapDrawerNo.value > 10) {
      this.highCapDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Maximum High Cap Drawer value : 10",
        constants.ToastPanelType.error,
        2
      );
    }

    else if (this.deviceTypeId.value === 14 && this.highCapSmartDrawerNo.value > sHcd400) {
      this.highCapSmartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart High Cap Drawer value : ${sHcd400}`,
        constants.ToastPanelType.error,
        2
      );
    }

    else if (this.deviceTypeId.value === 14 && this.smartDrawerNo.value > sd400) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawer value : ${sd400}`,
        constants.ToastPanelType.error,
        2
      );
    }

    else if ((this.deviceTypeId.value === 15) && this.highCapDrawerNo.value > 12) {
      this.highCapDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Maximum High Cap Drawer value : 12",
        constants.ToastPanelType.error,
        2
      );
    }

    else if (this.deviceTypeId.value === 15 && this.smartDrawerNo.value > sHcd480) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart High Cap Drawer value : ${sHcd480}`,
        constants.ToastPanelType.error,
        2
      );
    }

    else if (this.deviceTypeId.value === 15 && this.smartDrawerNo.value > sd480) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawer value : ${sd480}`,
        constants.ToastPanelType.error,
        2
      );
    }
    return output;
  }

  // Custom validator for asset number
  static assetNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return { required: true };
    }

    const value = control.value.toString().trim();

    // Check if it's exactly 6 digits
    if (!/^\d{6}$/.test(value)) {
      return { invalidAssetNumber: true };
    }

    // Check if it's all zeros
    if (value === '000000') {
      return { allZeros: true };
    }

    return null;
  }

  atpCapsValidationForAnalyze(): boolean {

    let output = false;
    let sd128 = 8 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let sHcd192 = 4 - this.highCapDrawerNo.value;
    let sd192 = 12 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let sHcd256 = 8 - this.highCapDrawerNo.value;
    let sd256 = 16 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let sd320 = 20 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let sHcd400 = 10 - this.highCapDrawerNo.value;
    let sd400 = 25 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let sHcd480 = 12 - this.highCapDrawerNo.value;
    let sd480 = 30 - ((this.highCapDrawerNo.value * 2) + (this.highCapSmartDrawerNo.value * 2));

    let initialCan: number = parseInt(this.countAnalysisDrugInfo[0]?.value == '' ? '0' : this.countAnalysisDrugInfo[0]?.value);
    let initialHighCan: number = parseInt(this.countAnalysisDrugInfo[2]?.value == '' ? '0' : this.countAnalysisDrugInfo[2]?.value);
    let initialSmartCan: number = parseInt(this.countAnalysisDrugInfo[1]?.value == '' ? '0' : this.countAnalysisDrugInfo[1]?.value);
    let initialSmartHighCan: number = parseInt(this.countAnalysisDrugInfo[3]?.value == '' ? '0' : this.countAnalysisDrugInfo[3]?.value);


    if (this.deviceId === 6 && this.initalCanister.value > initialCan) {
      output = true;
      this.initalCanister.setValue(initialCan);
      this.toastService.openToast(`Maximum Initial Canister value : ${initialCan}`,
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceId === 6 && this.highCapCanister.value > initialHighCan) {
      this.highCapCanister.setValue(initialHighCan);
      output = true;
      this.toastService.openToast(`Maximum Initial High Canister value : ${initialHighCan}`,
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceId === 6 && this.smartHighCapCanister.value > initialSmartHighCan) {
      this.smartHighCapCanister.setValue(initialSmartHighCan);
      output = true;
      this.toastService.openToast(`Maximum Initial High Canister value : ${initialSmartHighCan}`,
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceId === 6 && this.smartCanister.value > 999) {
      this.smartCanister.setValue(initialSmartCan);
      output = true;
      this.toastService.openToast("Maximum Initial Smart Canister value : 999",
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceTypeId.value === 24 && this.highCapDrawerNo.value > 0) {
      this.highCapDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("High Cap Drawer not possible for ATP2-64 device",
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceTypeId.value === 24 && this.highCapSmartDrawerNo.value > 0) {
      this.highCapSmartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Smart High Cap Drawer not possible for ATP2-64 device",
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceTypeId.value === 24 && this.smartDrawerNo.value > 4) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Maximum Smart Drawer value for ATP2-64 device : 4",
        constants.ToastPanelType.error,
        2
      );
    }
    else if ((this.deviceTypeId.value === 25 || this.deviceTypeId.value === 26) && this.highCapDrawerNo.value > 4) {
      this.highCapDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Maximum High Cap Drawer value : 4",
        constants.ToastPanelType.error,
        2
      );

    }
    else if ((this.deviceTypeId.value === 25 || this.deviceTypeId.value === 26) && this.highCapSmartDrawerNo.value > sHcd192) {
      this.highCapSmartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart High Cap Drawer value : ${sHcd192}`,
        constants.ToastPanelType.error,
        2
      );

    }

    else if (this.deviceTypeId.value === 25 && this.smartDrawerNo.value > sd128) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawer value : ${sd128}`,
        constants.ToastPanelType.error,
        2
      );

    }
    else if (this.deviceTypeId.value === 26 && this.smartDrawerNo.value > sd192) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawer value : ${sd192}`,
        constants.ToastPanelType.error,
        2
      );
    }

    else if ((this.deviceTypeId.value === 27 || this.deviceTypeId.value === 28) && this.highCapDrawerNo.value > 8) {
      this.highCapDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Maximum High Cap Drawer value : 8",
        constants.ToastPanelType.error,
        2
      );
    }
    else if ((this.deviceTypeId.value === 27 || this.deviceTypeId.value === 28) && this.highCapSmartDrawerNo.value > sHcd256) {
      this.highCapSmartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart High Cap Drawer value : ${sHcd256}`,
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceTypeId.value === 27 && this.smartDrawerNo.value > sd256) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawers value : ${sd256}`,
        constants.ToastPanelType.error,
        2
      );
    }
    else if (this.deviceTypeId.value === 28 && this.smartDrawerNo.value > sd320) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawers value : ${sd320}`,
        constants.ToastPanelType.error,
        2
      );
    }

    else if ((this.deviceTypeId.value === 29) && this.highCapDrawerNo.value > 10) {
      this.highCapDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Maximum High Cap Drawer value : 10",
        constants.ToastPanelType.error,
        2
      );
    }

    else if (this.deviceTypeId.value === 29 && this.highCapSmartDrawerNo.value > sHcd400) {
      this.highCapSmartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart High Cap Drawer value : ${sHcd400}`,
        constants.ToastPanelType.error,
        2
      );
    }

    else if (this.deviceTypeId.value === 29 && this.smartDrawerNo.value > sd400) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawer value : ${sd400}`,
        constants.ToastPanelType.error,
        2
      );
    }

    else if ((this.deviceTypeId.value === 30) && this.highCapDrawerNo.value > 12) {
      this.highCapDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast("Maximum High Cap Drawer value : 12",
        constants.ToastPanelType.error,
        2
      );
    }

    else if (this.deviceTypeId.value === 30 && this.smartDrawerNo.value > sHcd480) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart High Cap Drawer value : ${sHcd480}`,
        constants.ToastPanelType.error,
        2
      );
    }

    else if (this.deviceTypeId.value === 30 && this.smartDrawerNo.value > sd480) {
      this.smartDrawerNo.setValue(0);
      output = true;
      this.toastService.openToast(`Maximum Smart Drawer value : ${sd480}`,
        constants.ToastPanelType.error,
        2
      );
    }
    return output;
  }

  closeDialog(response: boolean) {
    this.dialogRefImportWizardComponent.close({ event: "close", data: response });
  }

  redirect() {
    this.dialogRefImportWizardComponent.close({ event: "close", data: false });
    this.route.navigate(['./im-tool']);
  }

  // Helper to set drugNameSource based on data source
  setDrugNameSource(sourceId: number) {
    const baseNames = [
      { key: 'Customer Drug Name', value: '1' },
      { key: 'Brand Name', value: '2' },
      { key: 'Generic Name', value: '3' },
      { key: 'Tall Man Name', value: '4' }
    ];
    // Only the display in the template should show WK/FDB, not the key
    this.drugNameSource = baseNames.map(item => ({
      key: item.key,
      value: item.value
    }));
  }

}
